// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.programs-bcbs-title {
  font-family: "Lato", sans-serif !important;
  font-size: 16px;
  margin: 0;
}

.programlist-page {
  background-color: rgb(247, 248, 249) !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.programlist-page .quickAcces-container {
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.16);
}

.programlist-page .headers-home {
  width: 100%;
  z-index: 10;
  padding: 0px !important;
  margin: 0px !important;
}

.programlist-page .logged-navbar {
  margin-bottom: 20px !important;
  position: sticky;
  top: 0;
  padding: 0px !important;
  z-index: 10;
}

.programlist-page .container-quick-access {
  align-self: flex-start;
  position: sticky !important;
  top: 0px;
  height: 100vh;
  margin-top: -20px !important;
  padding-left: 0;
}

.programlist-page .container-quickAccess-logged {
  padding-left: 0px !important;
  position: sticky !important;
  top: 0px;
  background-color: #e4e6eb;
}

.programlist-page .dropdowns-containers-navbar {
  margin: 0px !important;
  padding: 0px !important;
  width: 100% !important;
}

.programlist-page .footer-container {
  width: 96% !important;
  position: relative;
  height: 190px;
  padding: 0px !important;
  margin: 15px 0px 15px 0px !important;
  align-self: center !important;
}

.programlist-page .container-menu h6 {
  padding-left: 33px !important;
}

.programlist-page .container-data-programs-list {
  background-color: #e4e6eb !important;
  flex-direction: column;
  display: flex;
  align-self: center;
  padding-right: 25px !important;
}

.programlist-page .row-box-container {
  background-color: #e4e6eb !important;
}

.programlist-page .row-box-footer {
  align-self: center !important;
  align-items: center !important;
  align-content: center !important;
  justify-content: center !important;
  display: flex;
  width: 96% !important;
}

@media (max-width: 1400px) {
  .container-quick-access {
    margin: 0 !important;
    padding: 0 !important;
  }
}

@media (max-width: 1200px) {
  .programlist-page {
    background-color: #f7f8f9;
    padding: 0 !important;
    margin: 0px 64px !important;
    width: calc(100vw - 65px) !important;
  }
}

@media (max-width: 576px) {
  .programlist-page {
    background-color: #f7f8f9;
    padding: 0 !important;
    margin: 0px 0px !important;
    width: 100% !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/sass/layout/programsList/programsList.scss","webpack://./src/sass/utilities/_mixins.scss","webpack://./src/sass/layout/programsList/programsList.css"],"names":[],"mappings":"AAIA;ECKE,0CAAA;EACA,eAAA;EACA,SAAA;ACPF;;AAEA;EFCE,+CAAA;EACE,2BAAA;EECJ,0BAAA;EFEE,0BAAA;EACE,yBAAA;AEAJ;;AAEA;EACA,4CAAA;AFGE;;AEAF;EFGI,WAAA;EACA,WAAA;EACA,uBAAA;EEDJ,sBAAA;AFIE;;AEDF;EFII,8BAAA;EACA,gBAAA;EACA,MAAA;EACA,uBAAA;EEFJ,WAAA;AFKE;;AEFF;EFKI,sBAAA;EACA,2BAAA;EEHJ,QAAA;EFME,aAAA;EACE,4BAAA;EACA,eAAA;AEJJ;;AFQE;EACE,4BAAA;EACA,2BAAA;EACA,QAAA;EACA,yBAAA;AELJ;;AAEA;EFSI,sBAAA;EACE,uBAAA;EEPN,sBAAA;AFWE;;AERF;EFWI,qBAAA;EACA,kBAAA;EACA,aAAA;EETJ,uBAAA;EFYE,oCAAA;EACE,6BAAA;AEVJ;;AAEA;EFaI,6BAAA;AEXJ;;AAEA;EFaI,oCAAA;EEXJ,sBAAA;EACE,aAAa;EFaf,kBAAA;EACE,8BAAA;AEXF;;AAEA;EACA,oCAAA;AFaA;;AEVA;EACE,6BFYE;EEXF,8BFYE;EEXF,gCFYE;EEXF,kCAAA;EACF,aAAA;EFcA,qBAAA;AEZA;;AAEA;EACE;IFcE,oBAAA;IEZF,qBAAA;EACF;AACA;;AAEA;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;IAC3B,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,0BAA0B;IAC1B,sBAAsB;EACxB;AACF","sourcesContent":["@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n\n\n.programs-bcbs-title {\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 16px;\n  margin: 0;\n}\n\n.programlist-page {\n  @include settingsPage();\n\n  .quickAcces-container {\n    box-shadow: 0px 3px 15px rgb(0 0 0 / 16%);\n  }\n\n  .headers-home {\n    width: 100%;\n    z-index: 10;\n    padding: 0px !important;\n    margin: 0px !important;\n  }\n\n  .logged-navbar {\n    margin-bottom: 20px !important;\n    position: sticky;\n    top: 0;\n    padding: 0px !important;\n    z-index: 10;\n  }\n\n  .container-quick-access {\n    align-self: flex-start;\n    position: sticky !important;\n    top: 0px;\n    height: 100vh;\n    margin-top: -20px !important;\n    padding-left: 0;\n  }\n\n  .container-quickAccess-logged {\n    padding-left: 0px !important;\n    position: sticky !important;\n    top: 0px;\n    background-color: #e4e6eb;\n  }\n\n  .dropdowns-containers-navbar {\n    margin: 0px !important;\n    padding: 0px !important;\n    width: 100% !important;\n  }\n\n  .footer-container {\n    width: 96% !important;\n    position: relative;\n    height: 190px;\n    padding: 0px !important;\n    margin: 15px 0px 15px 0px !important;\n    align-self: center !important;\n  }\n\n  .container-menu {\n    h6 {\n      padding-left: 33px !important;\n    }\n  }\n\n  .container-data-programs-list {\n    background-color: #e4e6eb !important;\n    flex-direction: column;\n    display: flex;\n    align-self: center;\n    padding-right: 25px !important;\n  }\n\n  .row-box-container {\n    background-color: #e4e6eb !important;\n  }\n\n  .row-box-footer {\n    align-self: center !important;\n    align-items: center !important;\n    align-content: center !important;\n    justify-content: center !important;\n    display: flex;\n    width: 96% !important;\n  }\n}\n\n@media (max-width: 1400px) {\n  .container-quick-access {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n}\n\n@media (max-width: 1200px) {\n  .programlist-page {\n    background-color: #f7f8f9;\n    padding: 0 !important;\n    margin: 0px 64px !important;\n    width: calc(100vw - 65px) !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .programlist-page {\n    background-color: #f7f8f9;\n    padding: 0 !important;\n    margin: 0px 0px !important;\n    width: 100% !important;\n  }\n}","@import \"./variables\";\n\n@mixin flexCenter($justify-content, $align-items) {\n  display: flex;\n  justify-content: $justify-content;\n  align-items: $align-items;\n}\n\n@mixin settingsPage() {\n  background-color: $MainBackgroundColor !important;\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n",".programs-bcbs-title {\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 16px;\n  margin: 0;\n}\n\n.programlist-page {\n  background-color: rgb(247, 248, 249) !important;\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.programlist-page .quickAcces-container {\n  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.16);\n}\n\n.programlist-page .headers-home {\n  width: 100%;\n  z-index: 10;\n  padding: 0px !important;\n  margin: 0px !important;\n}\n\n.programlist-page .logged-navbar {\n  margin-bottom: 20px !important;\n  position: sticky;\n  top: 0;\n  padding: 0px !important;\n  z-index: 10;\n}\n\n.programlist-page .container-quick-access {\n  align-self: flex-start;\n  position: sticky !important;\n  top: 0px;\n  height: 100vh;\n  margin-top: -20px !important;\n  padding-left: 0;\n}\n\n.programlist-page .container-quickAccess-logged {\n  padding-left: 0px !important;\n  position: sticky !important;\n  top: 0px;\n  background-color: #e4e6eb;\n}\n\n.programlist-page .dropdowns-containers-navbar {\n  margin: 0px !important;\n  padding: 0px !important;\n  width: 100% !important;\n}\n\n.programlist-page .footer-container {\n  width: 96% !important;\n  position: relative;\n  height: 190px;\n  padding: 0px !important;\n  margin: 15px 0px 15px 0px !important;\n  align-self: center !important;\n}\n\n.programlist-page .container-menu h6 {\n  padding-left: 33px !important;\n}\n\n.programlist-page .container-data-programs-list {\n  background-color: #e4e6eb !important;\n  flex-direction: column;\n  display: flex;\n  align-self: center;\n  padding-right: 25px !important;\n}\n\n.programlist-page .row-box-container {\n  background-color: #e4e6eb !important;\n}\n\n.programlist-page .row-box-footer {\n  align-self: center !important;\n  align-items: center !important;\n  align-content: center !important;\n  justify-content: center !important;\n  display: flex;\n  width: 96% !important;\n}\n\n@media (max-width: 1400px) {\n  .container-quick-access {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n}\n\n@media (max-width: 1200px) {\n  .programlist-page {\n    background-color: #f7f8f9;\n    padding: 0 !important;\n    margin: 0px 64px !important;\n    width: calc(100vw - 65px) !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .programlist-page {\n    background-color: #f7f8f9;\n    padding: 0 !important;\n    margin: 0px 0px !important;\n    width: 100% !important;\n  }\n}\n\n/*# sourceMappingURL=programsList.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
